import { Helper } from "./helper.class.js";
export class Standard {
  /**
   * Static map method
   */
  static map(data, item = new this()) {
    return item.map(data);
  }
  /**
   * Map data into an object
   */
  map(data) {
    return Helper.map(data, this);
  }
  /**
   * Clone object (and map additional data)
   */
  clone(mapData) {
    const current = JSON.parse(JSON.stringify(this));
    if (mapData) {
      Object.assign(current, mapData);
    }
    return new this.constructor().map(current);
  }
  /**
   * Compare this with another object
   * Hint: functions will be ignored and when an array or an object is different the hole array or object will used as property value
   *
   * @return Record<string, any> with properties of this object which are different
   */
  getDiff(compare, clone = true) {
    return Helper.getDiff(this, compare, clone);
  }
}
